import React from 'react';
import { useState } from 'react'
import PlanIngredientsList from './PlanIngredientsList/PlanIngredientsList';
import { useData } from "../../../DataContext/DataProvider"

function PlanIngredients({ recipe, isActive, handlePair, backHandler }) {

    const dataContext = useData()
    const [highlightedIngredient, setHighlightedIngredient] = useState(null)
    const [searchValue, setSearchValue] = useState("");
    let ingredients = dataContext.ingredientsData.ingredients.filter((ingredient) => {
        return (
            (ingredient.Ingredient_Name.toLocaleUpperCase().includes(searchValue.toLocaleUpperCase()))//only ingredients matching the search query
            && (ingredient.Ingredient_Quantity >= highlightedIngredient?.Ingredient_Quantity)//that have the necessary quantity
            && (new Date(ingredient.Ingredient_Date) >= new Date(recipe.Plan_Date))//and are in date on the day the recipe is planned for
        )
    });
    const getStartOfToday = () => {
        const now = new Date().getTime();
        return now - now % 86400000
    }
    const isNotPast = new Date(getStartOfToday()) <= recipe.Plan_Date

    function handleSearch(e) {
        setSearchValue(e);
    }
    
    function handleClick(e) {
        setHighlightedIngredient({
            ...e,
            Recipe_Name: recipe.Recipe_Name,//todo see if this is necessary
            Recipe_ID: recipe.Recipe_ID,
            Plan_ID: recipe.Plan_ID
        })
        setSearchValue(e.Ingredient_Name)
    }

    function handleBack(e) {
        setHighlightedIngredient(null)
        backHandler(e)
    }

    function shopPlanHandler(ingredient) {
        dataContext.planData.handleShopPlan(ingredient, recipe)
    }

    function pairHandler(listIngredient) {
        setHighlightedIngredient(null);
        handlePair(highlightedIngredient, listIngredient)
    }

    return (
        <div className={"plan-ingredients-container row " + (isActive ? "active" : "inactive")}>
            <div className="column">
                <p>{recipe.Recipe_Name}</p>
                <button onClick={handleBack }>Back</button>
            </div>
            <ul className="recipe-ingredients-container">
                {
                    recipe.Recipe_Ingredients?.length > 0 ?
                        recipe.Recipe_Ingredients?.map((ingredient, index) => {
                            return (
                                <li key={index}
                                    className={
                                        (!ingredient?.Ingredient_ID && !ingredient.Item_ID && isNotPast ? "hoverable-element" : "visible-element") +
                                        (highlightedIngredient?.Recipe_Ingredient_ID === ingredient.Recipe_Ingredient_ID ? " selected-element" : "")
                                    }
                                    onClick={(e) => {
                                        if (!ingredient?.Ingredient_ID && !ingredient.Item_ID && isNotPast && (e.target.nodeName !== "BUTTON")) handleClick(ingredient)
                                    }}>
                                    <div className="row">
                                        <p>{ingredient.Ingredient_Name}: {ingredient.Ingredient_Quantity}</p>
                                        {ingredient.Ingredient_ID ? (<input className="ingredient-accounted-for" onMouseOver={(e) => e.preventDefault() } type="checkbox" checked="checked" readOnly/>) : null}
                                        {ingredient.Item_ID ? (<p>Shop Required</p>) : null}
                                        {(!ingredient.Ingredient_ID && !ingredient.Item_ID && isNotPast) ? <button onClick={(e) => { shopPlanHandler(ingredient);}}>Add to shopping list</button> : null}
                                        <div className="info-text-gap"></div>
                                        <span className="info-text">Click to view your ingredients</span>
                                    </div>
                                </li>
                            )
                    })
                    :<p>No ingredients present</p>
                }
            </ul>
            <div className={"ingredients-list-container " + (highlightedIngredient ? "visible" : "hidden")/*if there's no highlighted ingredient, we shouldn't see this tab at all*/}>
                <PlanIngredientsList ingredientsArray={ingredients} handleSearch={handleSearch} handlePair={pairHandler} searchValue={searchValue} />
            </div>
        </div>
    )
}
export default PlanIngredients